import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5410_9710)">
      <path
        d="M24.0007 12C24.0007 5.37258 18.6281 0 12.0007 0C5.37332 0 0.000732422 5.37258 0.000732422 12C0.000732422 18.6274 5.37332 24 12.0007 24C18.6281 24 24.0007 18.6274 24.0007 12Z"
        fill="url(#paint0_linear_5410_9710)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.2856 11.7589L13.9161 13.1283V14.7594V15.8651L16.2856 14.4957V11.7589ZM9.61785 8.42133L11.9873 9.79066L14.3568 8.42133L11.9873 7.05199L9.61785 8.42133ZM7.69097 13.1264V14.4957L8.33328 14.8649L10.0605 15.8632V13.1264L7.69097 11.7589V13.1283V13.1264ZM6.4064 15.236V16.7202L5.76409 16.3491L5.12183 15.9781V12.0151V8.05215L11.9873 4.08917L18.8528 8.05215V15.9799L15.4191 17.9614L13.9142 18.8298V17.3455L17.5683 15.236V9.5345L12.6296 12.3862C12.6296 13.1773 12.6296 13.9665 12.6296 14.7576V19.5718L11.9873 19.9429L11.345 19.5718L8.55363 17.9614L7.69097 17.4642V15.9799L11.345 18.0895V12.3881L6.4064 9.53637V15.2378V15.236ZM11.9873 11.273L7.04871 8.42133L11.9873 5.56964L16.926 8.42133L11.9873 11.273Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_5410_9710"
        x1="20.7141"
        y1="21.0955"
        x2="-13.8528"
        y2="-21.7643"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#8F00FF" />
        <stop offset="0.531658" stop-color="#78A5EA" />
        <stop offset="1" stop-color="#00FFC2" />
      </linearGradient>
      <clipPath id="clip0_5410_9710">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.000732422)"
        />
      </clipPath>
    </defs>
  </svg>
)
